export default __webpack_public_path__ + "static/media/Manrope-VariableFont_wght.95cc1657.ttf";